<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Уровни курса</h2>
      </div>
      <div class="d-flex">
        <div class="justify-content-center">
          <router-link to="/course-level/add" type="button" class="btn btn-primary my-2 btn-icon-text">
            <i class="fe fe-plus mr-2"></i> Добавить уровень
          </router-link>
        </div>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Список уровней курса</h6>
            </div>
            <div class="table-responsive">
              <b-table striped hover :items="courseLevelsList" :fields="tableFields" class="course-table">
                <template #cell(status)="row">
                  <span class="badge text-white"
                        :class="{'bg-success': row.item.status === 'active', 'bg-danger': row.item.status !== 'active'}">{{ row.item.status }}</span>
                </template>
                <template #cell(actions)="row">
                  <router-link :to="`/course-level/${row.item.id}`" class="btn btn-outline-primary">
                    <i class="fe fe-edit"></i>
                  </router-link>
                  <button v-if="row.item.status === 'active'" @click="deleteCourseLevel(row.item.id)" type="button"
                          class="btn btn-outline-danger ml-2">
                    <i class="ti-close"></i>
                  </button>
                  <div v-else class="d-inline-block">
                    <button @click="restoreCourseLevel(row.item.id)" type="button" class="btn btn-outline-success ml-2">
                      <i class="fe fe-rotate-ccw"></i>
                    </button>
                    <button @click="deleteCourseLevel(row.item.id)" type="button" class="btn btn-outline-danger ml-2">
                      <i class="fe fe-trash-2"></i>
                    </button>
                  </div>
                </template>
              </b-table>
              <div class="d-flex justify-content-end  mt-3">
                <div class="mr-3">
                  <b-form-select
                    @change="changePaginationPerPage"
                    style="width: 80px"
                    v-model="paginationPerPage"
                    :options="paginationOptions"
                  >
                  </b-form-select>
                </div>
                <div>
                  <b-pagination
                    class="m-0"
                    @change="changePagination"
                    v-model="paginationCurrentPage"
                    :total-rows="pagination.count"
                    :per-page="paginationPerPage"
                    first-text="<<"
                    prev-text="<"
                    next-text=">"
                    last-text=">>"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CourseLevel',
  data () {
    return {
      paginationOptions: [
        {
          value: 6,
          text: '6'
        },
        {
          value: 10,
          text: '10'
        },
        {
          value: 30,
          text: '30'
        },
        {
          value: 100,
          text: '100'
        }
      ],
      paginationCurrentPage: 1,
      paginationPerPage: 6,
      pagination: {}
    }
  },
  computed: {
    ...mapState({
      courseLevelsList: state => state.courseLevel.courseLevelsList
    }),
    tableFields () {
      return [
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },
        {
          key: 'name.' + this.$i18n.locale,
          label: 'Название',
          sortable: true
        },
        {
          key: 'status',
          label: 'Статус',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Действие',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.getCourseLevels().then(res => {
      this.pagination = res.pagination
    }).catch(() => {
      this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
    })
  },
  methods: {
    ...mapActions({
      getCourseLevels: 'courseLevel/getCourseLevels',
      delete: 'courseLevel/delete',
      restore: 'courseLevel/restore'
    }),
    changePaginationPerPage (value) {
      this.getCourseLevels({
        page: this.paginationCurrentPage,
        count: value
      })
    },
    changePagination (page) {
      this.getCourseLevels({
        page: page,
        count: this.paginationPerPage
      })
    },
    deleteCourseLevel (id) {
      Swal.fire({
        text: this.$t('messages.warning.delete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#748C41',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then((result) => {
        if (result.value) {
          this.delete(id).then(res => {
            this.$toasted.success(this.$t('messages.success.languageDeleted')).goAway(1500)
          }).catch(() => {
            this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
          })
        }
      })
    },
    restoreCourseLevel (id) {
      Swal.fire({
        text: this.$t('message.warning.restore'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#748C41',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then((result) => {
        if (result.value) {
          this.restore(id).then(res => {
            this.$toasted.success(this.$t('messages.success.languageRestored')).goAway(1500)
          }).catch(() => {
            this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
          })
        }
      })
    }
  }
}
</script>
<style>
.course-table thead th:last-child {
  width: 116px !important;
}
</style>
